import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { UiButtonComponent } from '../ui-button/ui-button.component';

export interface CustomObjectEditNameDialogData {
  currentName: string;
  customObjectId: number;
}

export interface CustomObjectEditNameDialogResult {
  saved: boolean;
  newName?: string;
}

@Component({
  selector: 'ui-custom-object-edit-name-dialog',
  templateUrl: './ui-custom-object-edit-name-dialog.component.html',
  styleUrls: ['./ui-custom-object-edit-name-dialog.component.scss'],
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatInputModule, TranslatePipe, UiButtonComponent],
})
export class UiCustomObjectEditNameDialogComponent {
  public newName: string;

  constructor(
    private dialogRef: MatDialogRef<UiCustomObjectEditNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomObjectEditNameDialogData,
  ) {
    this.newName = data.currentName || '';
  }

  public save(): void {
    if (this.newName.trim()) {
      this.dialogRef.close({ saved: true, newName: this.newName.trim() });
    }
  }

  public cancel(): void {
    this.dialogRef.close({ saved: false });
  }
}

